import React from 'react';
import { Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

export interface SearchBarProps {
  setSearchBarValue: React.Dispatch<React.SetStateAction<string>>;
  placeholder?: string;
  disabled?: boolean;
}

export const SearchBar = ({ setSearchBarValue, placeholder = 'Search Assets', disabled = false }: SearchBarProps) => {
  let debounceTimeout: any;

  const onSearch = (e: any) => {
    clearInterval(debounceTimeout);
    setSearchBarValue(e.target.value);
  };

  const onSearchChange = (e: any) => {
    clearInterval(debounceTimeout);
    debounceTimeout = setTimeout(() => {
      onSearch(e);
    }, 500);
  };

  return (
    <Input
      disabled={disabled}
      placeholder={placeholder}
      onChange={onSearchChange}
      onPressEnter={onSearch}
      prefix={<SearchOutlined />}
    />
  );
};
